document.addEventListener("DOMContentLoaded", function() {

    // ----------------------
    // Load More logic
    // ----------------------
    const cards = Array.from(document.querySelectorAll('.job-card'));
    const loadMoreBtn = document.querySelector('.load-more-button');
    let visibleCount = 6;

    function updateVisibility() {
        cards.forEach((card, index) => {
            card.style.display = index < visibleCount ? 'flex' : 'none';
        });

        if (visibleCount >= cards.length || cards.length <= 6) {
            loadMoreBtn.style.display = 'none';
        } else {
            loadMoreBtn.style.display = 'inline-flex';
        }
    }

    loadMoreBtn.addEventListener('click', function(e) {
        e.preventDefault();
        visibleCount += 6;
        updateVisibility();
    });

    // Initially check visibility
    updateVisibility();

    // ----------------------
    // Sort logic
    // ----------------------
    const sortSelect = document.getElementById('job-sort');

sortSelect.addEventListener('change', function() {
    const value = this.value;
    const container = document.querySelector('.job-cards');

    // Clone and sort the cards
    let sortedCards = Array.from(document.querySelectorAll('.job-card')); // always reselect
    if (value === 'newest') {
        sortedCards.sort((a, b) => {
            const dateA = new Date(a.querySelector('.job-date').textContent.replace('Posted on ', '').trim());
            const dateB = new Date(b.querySelector('.job-date').textContent.replace('Posted on ', '').trim());
            return dateB - dateA; // Newest first
        });
    } else if (value === 'oldest') {
        sortedCards.sort((a, b) => {
            const dateA = new Date(a.querySelector('.job-date').textContent.replace('Posted on ', '').trim());
            const dateB = new Date(b.querySelector('.job-date').textContent.replace('Posted on ', '').trim());
            return dateA - dateB; // Oldest first
        });
    } else if (value === 'az') {
        sortedCards.sort((a, b) => {
            return a.querySelector('h3').textContent.trim().localeCompare(
                b.querySelector('h3').textContent.trim()
            );
        });
    } else if (value === 'za') {
        sortedCards.sort((a, b) => {
            return b.querySelector('h3').textContent.trim().localeCompare(
                a.querySelector('h3').textContent.trim()
            );
        });
    }

    // Replace container contents with sorted cards
    container.innerHTML = '';
    sortedCards.forEach(card => container.appendChild(card));

    // Update the global cards array reference
    cards.length = 0; // clear it
    sortedCards.forEach(card => cards.push(card));

    // Reset visible count and update display
    visibleCount = 6;
    updateVisibility();
});


    // ----------------------
    // Modal logic
    // ----------------------
    const modal = document.getElementById('job-modal');
    const modalHeader = modal.querySelector('.job-modal-header-dynamic');
    const modalBody = modal.querySelector('.job-modal-body-dynamic');
    const modalFooter = modal.querySelector('.job-modal-footer-dynamic');
    const modalClose = modal.querySelector('.job-modal-close');

    document.querySelectorAll('.job-card').forEach(function(card) {
        card.addEventListener('click', function() {
            const jobId = card.getAttribute('data-job');
            const jobContent = document.getElementById('job-content-' + jobId);

            modalHeader.innerHTML = jobContent.querySelector('.job-modal-header').innerHTML;
            modalBody.innerHTML = jobContent.querySelector('.job-modal-body').innerHTML;
            modalFooter.innerHTML = jobContent.querySelector('.job-modal-footer').innerHTML;

            modal.style.display = 'block';
            document.body.style.overflow = 'hidden'; // prevent page scroll

// Accordion logic
modalBody.querySelectorAll('.accordion').forEach(function(acc) {
    acc.onclick = function() {
        this.classList.toggle('active');

        // Find the panel: it's the next sibling of the parent <p>
        var pTag = this.closest('p');
        if (!pTag) return;
        var panel = pTag.nextElementSibling;
        if (!panel || !panel.classList.contains('panel')) return;

        // Toggle panel open/close with class
        if (panel.classList.contains('open')) {
            panel.classList.remove('open');
        } else {
            panel.classList.add('open');
        }

        // Swap the icons
        const plusIcon = this.querySelector('.icon-plus');
        const minusIcon = this.querySelector('.icon-minus');
        if (this.classList.contains('active')) {
            if (plusIcon) plusIcon.style.display = 'none';
            if (minusIcon) minusIcon.style.display = 'block';
        } else {
            if (plusIcon) plusIcon.style.display = 'block';
            if (minusIcon) minusIcon.style.display = 'none';
        }
    };
});


        });
    });

    // ----------------------
    // Close modal events
    // ----------------------
    modalClose.addEventListener('click', function() {
        modal.style.display = 'none';
        document.body.style.overflow = ''; // restore scroll
    });

    window.addEventListener('click', function(e) {
        if (e.target === modal) {
            modal.style.display = 'none';
            document.body.style.overflow = '';
        }
    });

});